import React, { useState, useEffect } from 'react';
import styles from './MobileNavigation.module.scss';
import Accordion from './Accordion/Accordion';

export default function MobileNavigation({ menuInfo }) {
  // 只使用 Sitecore 数据，不使用默认数据
  const transformData = (data) => {
    if (!data || data.length === 0) {
      return [];
    }

    // Sitecore 数据格式转换
    return data.map((item) => ({
      id: item.id,
      title: item.fields.title?.value || item.fields.title,
      items:
        item.fields.Children?.map((child) => ({
          id: child.id,
          title: child.fields.title?.value || child.fields.title,
          path:
            `${child.fields.Link?.value?.href || ''}${
              child.fields.Link?.value?.querystring || ''
            }` || child.fields.Link?.href,
        })) || [],
      isOpen: false,
    }));
  };

  const [data, setData] = useState(() => transformData(menuInfo));

  // 当 menuInfo 改变时更新数据
  useEffect(() => {
    setData(transformData(menuInfo));
  }, [menuInfo]);

  const handleOpen = (id) => {
    setData((prevData) =>
      prevData.map((item) => (item.id === id ? { ...item, isOpen: !item.isOpen } : item))
    );
  };

  // 如果没有数据，不渲染导航
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <nav className={styles.navigation}>
      {data.map((item) => (
        <Accordion key={item.id} item={item} onOpen={handleOpen} />
      ))}
    </nav>
  );
}
